import { render, staticRenderFns } from "./StoreAndMedia.vue?vue&type=template&id=5bb60afd&scoped=true"
import script from "./StoreAndMedia.vue?vue&type=script&lang=js"
export * from "./StoreAndMedia.vue?vue&type=script&lang=js"
import style0 from "./StoreAndMedia.vue?vue&type=style&index=0&id=5bb60afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb60afd",
  null
  
)

export default component.exports